export function returnBaseUrl(ambiente: string, porta?: string): string {
  if (ambiente === 'des') {
    return 'https://des-pgrm.np.estaleiro.serpro.gov.br/';
  } else if (ambiente === 'hom') {
    return 'https://hom-pgrm.estaleiro.serpro.gov.br/';
  } else if (ambiente === 'local') {
    return `http://localhost:${porta ?? '8080'}/`;
  } else if (ambiente === 'pro') {
    return 'https://pgrm.serpro.gov.br/';
  } else if (ambiente === 'ppro') {
    return 'https://ppro-pgrm.estaleiro.serpro.gov.br/';
  } else {
    return '';
  }
}

export function returnPlataformaUrl(ambiente: string): string {
  if (ambiente === 'local') {
    return returnBaseUrl('des');
  } else {
    return returnBaseUrl(ambiente);
  }
}

export function returnLoginUrl(ambiente: string): string {
  const plataformaUrl = returnPlataformaUrl(ambiente);

  return plataformaUrl + 'pgrm/api/auth/login';
}

export function returnLogoutUrl(ambiente: string): string {
  const plataformaUrl = returnPlataformaUrl(ambiente);

  return plataformaUrl + 'pgrm/api/auth/logout';
}
